<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Clocks' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    @for (clock of match.clocks; track clock.name) {
    <ion-item>
      <ion-label>
        {{ clock.name | translate }}
        <ion-text color="gray">
          <p>Type: {{ clock.type | translate }}</p>
          <p>Default value: {{ clock.defaultValue | translate | date: clock.timePipe }}</p>
        </ion-text>
      </ion-label>
      <ion-button color="danger" (click)="deleteClock(clock._id)" fill="clear">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button>
    </ion-item>
    }
  </ion-list>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button id="open-modal">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <!-- Create clock modal -->
  <ion-modal trigger="open-modal" (willDismiss)="closeAddClock($event)">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button color="dark" (click)="closeAddClock()">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title>{{ 'Add Clock' | translate }}</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <form [formGroup]="form">
          <ion-list>
            <!-- Select clock -->
            <ion-item>
              <ion-select label="{{ 'Select clock' | translate }}" label-placement="floating" interface="popover"
                formControlName="name">
                <ion-select-option [value]="clockName.WARM_UP">{{ clockName.WARM_UP | translate }}</ion-select-option>
                <ion-select-option [value]="clockName.POINT_BREAK">{{ clockName.POINT_BREAK | translate
                  }}</ion-select-option>
                <!-- <ion-select-option [value]="clockName.GAME_BREAK">{{ clockName.GAME_BREAK | translate }}</ion-select-option> -->
                <ion-select-option [value]="clockName.SET_TIME">{{ clockName.SET_TIME | translate }}</ion-select-option>
                <!-- <ion-select-option [value]="clockName.MEDICAL_TIMEOUT">{{ clockName.MEDICAL_TIMEOUT | translate }}</ion-select-option> -->
                <ion-select-option [value]="clockName.TIMEOUT">{{ clockName.TIMEOUT | translate }}</ion-select-option>
                <ion-select-option [value]="clockName.SET_BREAK">{{ clockName.SET_BREAK | translate }}</ion-select-option>
              </ion-select>
            </ion-item>

            @if (form.get('name').value){
            <!-- Timeout per match -->
            @if (form.get('name').value === clockName.TIMEOUT) {
            <ion-item>
              <ion-select label="{{ 'Timeout per match' | translate }}" label-placement="stacked" interface="popover"
                formControlName="timeoutPerMatch" (ionChange)="form.updateValueAndValidity()">
                @for (number of timeoutOptions; track number) {
                <ion-select-option [value]="number.toString()">{{ number }}</ion-select-option>
                }
              </ion-select>
            </ion-item>

            <ion-item>
              <ion-select label="{{ 'Timeout per set' | translate }}" label-placement="stacked" interface="popover"
                formControlName="timeoutPerSet" (ionChange)="form.updateValueAndValidity()">
                @for (number of timeoutOptions; track number) {
                <ion-select-option [value]="number.toString()">{{ number }}</ion-select-option>
                }
              </ion-select>
            </ion-item>

            }


            <!-- Clock type -->
            <ion-item>
              <ion-select label="{{ 'Clock type' | translate }}" label-placement="stacked" interface="popover"
                formControlName="type">
                <ion-select-option [value]="clockType.STOPWATCH">{{ clockType.STOPWATCH | translate
                  }}</ion-select-option>
                <ion-select-option [value]="clockType.TIMER">{{ clockType.TIMER | translate }}</ion-select-option>
              </ion-select>
            </ion-item>

            <!-- Clock format -->
            <ion-item>
              <ion-select label="{{ 'Clock format' | translate }}" label-placement="stacked" interface="popover"
                formControlName="timePipe">
                <ion-select-option [value]="'h:mm:ss'">hh:mm:ss</ion-select-option>
                <ion-select-option [value]="'m:ss'">m:ss</ion-select-option>
                <ion-select-option [value]="'ss'">ss</ion-select-option>
              </ion-select>
            </ion-item>

            <!-- Clock default value -->
            <ion-item>
              <ion-input (click)="timePicker.setOpen(true)" readonly label="{{ 'Default clock value in seconds' | translate }}"
                labelPlacement="stacked" placeholder="Enter time in seconds"
                [value]="form.get('defaultValue').value | date: 'm:ss'"></ion-input>
            </ion-item>
            }

          </ion-list>
        </form>
      </ion-content>
      <ion-footer>
        <ion-toolbar>
          <ion-button color="primary" class="ion-margin" (click)="save()" expand="block">
            {{ 'Save' | translate }}
          </ion-button>

        </ion-toolbar>
      </ion-footer>
    </ng-template>
  </ion-modal>

  <app-time-picker #timePicker [value]="form.get('defaultValue').value"
    (updateValue)="updateClock($event)"></app-time-picker>

</ion-content>